import { render, staticRenderFns } from "./SystemPermissionEditButton.vue?vue&type=template&id=3182b006&scoped=true"
import script from "./SystemPermissionEditButton.vue?vue&type=script&lang=js"
export * from "./SystemPermissionEditButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3182b006",
  null
  
)

export default component.exports